import { gql } from '@apollo/client';

export const ADMIN_GET_PERSON = gql`
  query User($personId: Int!) {
    user(personId: $personId) {
      id
      records {
        id
      }
      siblings {
        id
        name
        photoUrl
      }
      parents {
        id
        name
        photoUrl
      }
      children {
        id
        name
        photoUrl
      }
      photoUrl
      buddies {
          id
          name
          photoUrl
      }
      currentCourseAttendances {
        attendance {
            id
            status
        }
        courseId
        course {
            id
            name
            SKU
            teachers {
                id
                name
                photoUrl
            }
        }
      }
      isArchived
      uploadURLSmall
      scriptName
      gender
      haveRegistrationDocument
      registrationDocumentUrl
      hasNewRegistration
      # Both of these are gated server-side: registration comes back null and
      # supportingDocuments empty for anyone who may not see them, so the UI needs no
      # role check of its own. The list and the gate are one answer.
      registration {
        id
        completedAt
        consentDataAggregate
        consentDataReporting
        consentDataPrograms
        consentDataCollection
        consentHealthSafety
        idSightedByCM
        guardianName
        guardianDob
        guardianRelationship
        guardianIsMinorNoAlternative
        guardianConsentsToChildData
        guardianIdSightedConfirmsRelationship
        guardianNoIdButConfirmed
        guardianPhone
        emergencyContactName
        emergencyContactPhone
        emergencyContactRelationship
        # Admins and social workers only — null for anyone else, including centre managers.
        healthInformation
        canSeeHealthInformation
      }
      supportingDocuments {
        id
        kind
        fileName
        contentType
        createdAt
        url
      }
      preferredName
      identifier
      name
      dob
      tags {
        id
        name
      }
      address
      attendancePercentage
      truency
      picturePermission
      # Blank for a viewer the server will not show it to. canAddEmail folds the authority,
      # the scope and the state into one answer -- see backend utils/personEmail.ts.
      email
      canAddEmail
      # Whether this person can sign in, and whether this viewer may give them a way to.
      # canCreateLogin folds the capability, the scope and the state into one answer the same
      # way canAddEmail does -- see backend graphql/Login.ts. canSignIn is deliberately a
      # boolean and not the username: which identifier somebody uses stays behind the existing
      # username gate, and the question here is only whether to offer.
      canSignIn
      canCreateLogin
      coursesTeaching {
        id
        name
        SKU
      }
      courses {
        id
        name
        SKU
      }
    }
  }
`;
